// this is so it is backwards compatible
import { AppContext } from '@send-route-components/App/context/Context';

export { AppContext };
